/* guard managing access to the admin module
*  conditions to allow access:
*   - useractive must be true
*   - isPasswordUpdateRequired must be false
*   - userrole must be 'Admin'
* */

import {CanActivateFn, Router, UrlTree} from "@angular/router";
import {inject} from "@angular/core";
import {combineLatest, distinctUntilChanged, from, map, Observable, of} from "rxjs";
import {Userrole} from "../../shared/interfaces/user";
import {UserService} from "../../services/user.service";

export const adminGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const userService = inject(UserService);
  const router = inject(Router);
  const userroleType = Userrole;

  // combine latest with appUserMetaData and requirePasswordUpdate
  return combineLatest([
    of(userService.user()!.app_metadata['userrole'] as Userrole),
    of(userService.isPasswordUpdateRequired() as boolean),
    of(userService.isActive() as boolean)
  ]).pipe(
    distinctUntilChanged(),
    map(([userrole, isPasswordUpdateRequired, useractive]) => {
      if (!useractive) {
        alert(
          "Ihr Account wurde deaktiviert. Bitte wenden Sie sich an den Administrator"
        );
        return false;
      } else if (isPasswordUpdateRequired) {
        // TODO: implement notificationService
        alert("Bitte ändern Sie ihr Passwort");
        return router.createUrlTree(["/reset-password"]);
      } else {
        return userrole === userroleType.Admin
      }
    }),
  );
};
